import { boolean } from 'boolean'
import { ComponentType } from 'react'
import { IoMdPin } from 'react-icons/io'
import { Button } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Text = styled.span`
  display: none;

  ${up('sm')} {
    display: inline;
  }
`

export const MapToggle: ComponentType<{
  query: any
  onSubmit: (changes: any) => void
}> = ({ query, onSubmit }) => {
  const mapView = boolean(query.map)

  return (
    <Button
      color={mapView ? 'primary' : 'dimmed'}
      outline={!mapView}
      className="text-nowrap"
      onClick={() => onSubmit({ map: !mapView })}
    >
      <Text>Mapa</Text> <IoMdPin />
    </Button>
  )
}
